import React, { useState } from 'react';
import { useTranslate } from '@bynder/localization';

import { IconSettings } from '@bynder/icons';
import { useOutsideClick } from '../../helpers/useOutsideClick';
import { useAccountMenuItems } from './useAccountMenuItems';
import { Dropdown } from '../Dropdown/Dropdown';
import { WFGroupsModal } from '../WorkflowGroupsManagement/WFGroupsModal';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm
 */
export function AccountMenu() {
	const menuItems = useAccountMenuItems();
	const { translate } = useTranslate();
	const [isOpen, setIsOpen] = useState(false);
	const [isPinned, setIsPinned] = useState(false);

	const onOutsideClicked = () => {
		setIsPinned(false);
		setIsOpen(false);
	};

	const refButton = React.useRef<HTMLLIElement>(null);
	useOutsideClick(refButton, onOutsideClicked);

	if (menuItems.length === 0) {
		return <li className="touch-block" />;
	}

	const onPinned = () => {
		setIsPinned((prev) => !prev);
	};

	const openDropdown = () => {
		setIsOpen(true);
	};

	const closeDropdown = () => {
		setIsOpen(false);
	};

	const onItemClick = () => {
		setIsPinned(true);
	};

	return (
		<>
			<li
				ref={refButton}
				onMouseEnter={openDropdown}
				onMouseLeave={closeDropdown}
				className={`touch-block ${isPinned ? 'hover' : ''}`}
			>
				<a onClick={onPinned} href="#" className="admin-dropdown settings">
					<IconSettings />
					{translate('generalSettings')}
				</a>

				{(isOpen || isPinned) && <Dropdown onItemClick={onItemClick} items={menuItems} />}
			</li>

			<WFGroupsModal />
		</>
	);
}
